// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"816fbc42","454":"3a12d1c9","568":"caf44552","582":"7f23fd1d","613":"90c31b3e","714":"3fca103b"}[chunkId] + ".chunk.js";
};